import React, { useState, useEffect } from 'react'
import { API_URL, formatDate, secret_key, storedData, mapMessage } from '../Constants';
import InfiniteScroll from 'react-infinite-scroll-component';
import axios from 'axios';
import CryptoJS from "crypto-js";
import loading1 from "../../assets/loading.gif"

function Failedsms() {
  const [searchTerm, setSearchTerm] = useState('');
  const [Fsms, setFsms] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);

  const encryptedToken = localStorage.getItem('token');
  let decryptedToken = '';

  if (encryptedToken) {
    try {
      const decryptedBytes = CryptoJS.AES.decrypt(encryptedToken, secret_key);
      decryptedToken = decryptedBytes.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      console.log('Error.');
    }
  }

  const token = `Bearer ${decryptedToken}`;

  if (storedData) {
    var bytes = CryptoJS.AES.decrypt(storedData, secret_key);
    var logeduserData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  }

  const fetchFsms = () => {
    const getFsmsURL = `${API_URL}/get_failed_messages/${logeduserData?.company_id}?page=${page}&limit=${50}`;
      let getmessageConfig = {
        method: 'get',
        maxBodyLength: Infinity,
        url: getFsmsURL,
        headers: { 
          'Authorization': token
        }
      };
  
      axios
      .request(getmessageConfig)
      .then(function (response) {
        if (response.data.length === 0) {
          setHasMore(false);
        } else {
          setFsms([...Fsms, ...response.data]);
          setPage(page + 1);
        }
      })
      .catch(function (error) {
        // handle errors
        console.log(error?.response);
      });
  };

  useEffect(() => {
    fetchFsms();
  }, []);

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
    fetchFsms();
  };

  const filteredFsms = Fsms.filter((Fsms) => {
    const { id, phone_no, message_body, created_at } = Fsms;
    const lowerCaseSearchTerm = searchTerm.toLowerCase();
    return (
      id.toString().toLowerCase().includes(lowerCaseSearchTerm) ||
      phone_no.toLowerCase().includes(lowerCaseSearchTerm) ||
      message_body.toLowerCase().includes(lowerCaseSearchTerm) ||
      created_at.toLowerCase().includes(lowerCaseSearchTerm)
    );
  });

  const loadMoreFsms = () => {
    fetchFsms(); // Fetch more Fsms when the user scrolls to the bottom
  };

  return (
    <div style={{ paddingLeft: '10px' }}>
      <div className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-6">
                  <h1 className="m-0">Failed Messages</h1>
                </div>{/* /.col */}
                <div className="col-sm-6">
                  <ol className="breadcrumb float-sm-right">
                    <li className="breadcrumb-item"><a href="/">Home</a></li>
                    <li className="breadcrumb-item active">Messages</li>
                  </ol>
                </div>{/* /.col */}
              </div>{/* /.row */}
            </div>{/* /.container-fluid */}
        </div>

      <form className="form-inline justify-content-end searchBar">
        <div className="input-group input-group-sm">
          <input
            className="form-control form-control-navbar"
            type="search"
            placeholder="Search"
            aria-label="Search"
            value={searchTerm}
            onChange={handleSearch}
          />
        </div>
      </form>

          <InfiniteScroll

            dataLength={filteredFsms.length}
            next={loadMoreFsms}
            hasMore={hasMore}
            loader={filteredFsms.length > 0 ? null : 
              <div className="loadingsubcontainer">
                <img className="loadingsubimg" src={loading1} alt="" />
              </div>}
            endMessage={<p>No more sms to load.</p>}
          >
            <table id="example" className="table table-striped">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Phone No</th>
                  <th>Message</th>
                  <th>Created At</th>
                  <th>Sender id</th>
                  <th>Sent</th>
                  <th>Response </th>
                </tr>
              </thead>
              <tbody>
                  {filteredFsms.map((Fsms) => (
                    <tr key={Fsms.id}>
                      <td>{Fsms.id}</td>
                      <td>{Fsms.phone_no}</td>
                      <td style={{ maxWidth: '300px', wordWrap: 'break-word' }}>{mapMessage(Fsms.message_body)}</td>
                      <td>{formatDate(Fsms.created_at)}</td>
                      <td>{Fsms.sender_id}</td>
                      <td>{Fsms.status}</td>
                      <td>{Fsms.server_response}</td>
                    </tr>
                  ))}
              </tbody>
            </table>
        </InfiniteScroll>
      
    </div>
  )
}

export default Failedsms